import type { ChatMessage as ApiMessage } from '../../lib/api'
import { MarkdownRenderer } from '../content/MarkdownRenderer'
import { User, Bot } from 'lucide-react'

export interface ChatMessageProps {
  message: ApiMessage
}

export function ChatMessage({ message }: ChatMessageProps) {
  const isUser = message.role === 'user'
  const isAssistant = message.role === 'assistant'

  return (
    <div
      className={`flex gap-3 ${isUser ? 'flex-row-reverse' : ''}`}
      data-message-id={message.id}
    >
      <div
        className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${
          isUser ? 'bg-emerald-600 text-white' : 'bg-slate-200 text-slate-600'
        }`}
      >
        {isUser ? <User className="w-4 h-4" /> : <Bot className="w-4 h-4" />}
      </div>
      <div
        className={`flex-1 min-w-0 max-w-[85%] ${
          isUser ? 'text-right' : ''
        }`}
      >
        <div
          className={`inline-block rounded-2xl px-4 py-2.5 text-left ${
            isUser
              ? 'bg-emerald-600 text-white rounded-tr-sm'
              : 'bg-white border border-slate-200 text-slate-800 rounded-tl-sm shadow-sm'
          }`}
        >
          {isAssistant ? (
            <div className="prose-chat">
              <MarkdownRenderer
                content={message.content}
                className="text-sm prose-p:my-1.5 prose-ul:my-1.5 prose-ol:my-1.5"
                cleanPreface={true}
              />
            </div>
          ) : (
            <p className="text-sm whitespace-pre-wrap break-words">
              {message.content}
            </p>
          )}
        </div>
        <p
          className={`text-xs text-slate-400 mt-1 ${
            isUser ? 'text-right' : 'text-left'
          }`}
        >
          {new Date(message.created_at).toLocaleTimeString(undefined, {
            hour: '2-digit',
            minute: '2-digit',
          })}
        </p>
      </div>
    </div>
  )
}
